<template>
  <div class="page-static " :class="`page-static-${nid}`" ref="pageWrapper">
    <div class="top-wrapper" ref="pageTopWrapper">
      <div class="title">{{node.title}}</div>
    </div>

    <article class="node node-type-article">
      <div class="page-body-wrapper" ref="pageBodyWrapper">
        <article class="node node-type-article">
          <div class="article-parent-wrapper">
            <page-body :nid="nid"></page-body>
          </div>
        </article>
      </div>
    </article>

    <div class="email-us-wrapper">
      <a href="mailto:edt.customerserv@scmp.com" >
        <div class="email-us-button">
          <span>EMAIL US</span>
        </div>
      </a>
    </div>

    <div class="credit-wrapper">
      <div class="monster-head">
        <div class="monsters">
          <div class="monster-shadow"><svg-alien-giant></svg-alien-giant></div>
          <div class="monster-main"><svg-alien-giant></svg-alien-giant></div>
        </div>
      </div>
      <div class="list">
        <div class="the-team">THE TEAM</div>
        <div class="items">
          <div class="item" v-for="(value, index) in authorList" key="index">
            <div class="alien-icon"><component :is="assignAlien(index)" :nid="nid"></component></div>
            <div class="equal">=</div>
            <div class="name">
              <term-link v-if="value.tid" :tid="value.tid" :title="value.title" :url="value.relative_url" :type="value.type">{{ value.title }}</term-link>
            </div>
            <div class="contacts">
              <a :href="get(value, 'links.facebook', 'javascript:void(0)')" target="_blank" :class="{'link--default': !get(value, 'links.facebook')}">
                <div class="facebook contact" :class="{dim: !get(value, 'links.facebook')}">
                  <component :is="`svg-contact-fb${!get(value, 'links.facebook') ? '-grey' : ''}`" ></component>
                </div>
              </a>
              <a :href="get(value, 'links.twitter', 'javascript:void(0)')" target="_blank" :class="{'link--default': !get(value, 'links.twitter')}">
                <div class="twitter contact" :class="{dim: !get(value, 'links.twitter')}">
                  <component :is="`svg-contact-twitter${!get(value, 'links.twitter') ? '-grey' : ''}`" ></component>
                </div>
              </a>
              <a :href="get(value, 'links.instagram', 'javascript:void(0)')" target="_blank" :class="{'link--default': !get(value, 'links.instagram')}">
                <div class="instagram contact" :class="{dim: !get(value, 'links.instagram')}">
                  <component :is="`svg-contact-instagram${!get(value, 'links.instagram') ? '-grey' : ''}`" ></component>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="disclaimer-wrapper">Abacus is a unit of the South China Morning Post Publishers Ltd.</div>

    <div class="address-wrapper">
      <div class="address__header">South China Morning Post</br>Publishers Ltd.</div>
      <hr>
      <div class="address__body">
        <div>19/F., Tower 1, Times Square, 1 Matheson Street, Causeway Bay, Hong Kong</div>
        <a href="tel:+85225658822">(852) 2565 8822</a>
      </div>
    </div>


  </div>
</template>

<script>
  import get from 'lodash/get'
  import PageBody from 'components/node/page/PageBody.vue'
  import TermLink from 'components/term/Link'

  import { freezeFixedPosition } from 'mixins/utilities'

  import SvgAlienGiant from 'static/svg/icon_about_us_alien_giant.svg'
  import SvgAlienIcon1 from 'static/svg/icon_about_us_alien_small_1.svg'
  import SvgAlienIcon2 from 'static/svg/icon_about_us_alien_small_2.svg'
  import SvgAlienIcon3 from 'static/svg/icon_about_us_alien_small_3.svg'
  import SvgAlienIcon4 from 'static/svg/icon_about_us_alien_small_4.svg'
  import SvgAlienIcon5 from 'static/svg/icon_about_us_alien_small_5.svg'
  import SvgAlienIcon6 from 'static/svg/icon_about_us_alien_small_6.svg'
  import SvgAlienIcon7 from 'static/svg/icon_about_us_alien_small_7.svg'

  import SvgContactFb from 'static/svg/raw/icon_contact_fb.svg'
  import SvgContactTwitter from 'static/svg/raw/icon_contact_tw.svg'
  import SvgContactInstagram from 'static/svg/raw/icon_contact_ig.svg'
  import SvgContactFbGrey from 'static/svg/raw/icon_contact_fb_grey.svg'
  import SvgContactTwitterGrey from 'static/svg/raw/icon_contact_tw_grey.svg'
  import SvgContactInstagramGrey from 'static/svg/raw/icon_contact_ig_grey.svg'

  import { mapState } from 'vuex'

  export default {
    props: ['nid'],
    data() {
      return {
        headerBgColor: '#dc3a35',
        navigation: false,
        numOfAlien: 7,
      }
    },
    components: {
      TermLink,
      PageBody,
      SvgAlienGiant,
      SvgAlienIcon1,
      SvgAlienIcon2,
      SvgAlienIcon3,
      SvgAlienIcon4,
      SvgAlienIcon5,
      SvgAlienIcon6,
      SvgAlienIcon7,
      SvgContactFb,
      SvgContactTwitter,
      SvgContactInstagram,
      SvgContactFbGrey,
      SvgContactTwitterGrey,
      SvgContactInstagramGrey,
    },
    computed: {
      ...mapState([
        'termQueue',
      ]),
      node() {
        return this.$store.getters.node(this.nid) || {}
      },
      authorList() {
        return get(this, 'termQueue.termqueue_abacus_editorial_team_list.content', [])
      },
    },
    mounted() {
      freezeFixedPosition(true)
      this.navigation = get(this, '$parent.$parent.$refs.header.$refs.navbar.$el', false)
      this.navigation.classList.add('inpage-menu')
      setTimeout(() => {
        this.navigation.classList.add('inpage')
      }, 800)
    },
    destroyed() {
      freezeFixedPosition(false)
      this.navigation.classList.remove('inpage')
      this.navigation.classList.remove('inpage-menu')
    },
    methods: {
      get,
      socialIcon(name) {
        return name || ''
      },
      assignAlien(index) {
        const getAlien = (index) % this.numOfAlien
        return `svg-alien-icon${getAlien + 1}`
      },
    },
  }

</script>

<style lang="scss" scoped>
  .page-static {
    background: $cg-red;
    overflow-x: hidden;
    padding-bottom: $footer-spacing-top;
    .top-wrapper {
      background: $cg-red;
      width: 100%;
      .title {
        font-family: $bungee-inline;
        font-size: rem-calc(134);
        color: $white;
        max-width: rem-calc(700);
        position: relative;
        margin: auto;
        padding: rem-calc(100 0 10 0);
        line-height: rem-calc(102);
        @include respond-to('mobile') {
          font-size: rem-calc(36);
          padding: rem-calc(75 27 0 27);
          line-height: rem-calc(35);
        }
      }
    }

    .node-type-article {
      font-family: $barlow;
      color: $white;
      .article-parent-wrapper {
        position: relative;
        background: $cg-red;
        z-index: 1;
        height: 100%;
      }
    }

    .email-us-wrapper {
      margin: auto;
      position: relative;
      text-align: center;
      font-size: rem-calc(18);
      padding-bottom: rem-calc(40);
      .email-us-button {
        width: rem-calc(240);
        height: rem-calc(40);
        background: $light-salmon-pink;
        color: $cg-red;
        display: inline-block;
        line-height: rem-calc(40);
        font-size: rem-calc(24);
        font-family: $silkscreen;
      }
    }

    $creditWrapperWidth: 375;
    .credit-wrapper{
      position: relative;
      width: rem-calc($creditWrapperWidth);
      margin: auto;

      .monster-head {
        width: inherit;
        height: rem-calc(50);
        .monsters{
          width: inherit;
          position: relative;
          svg {
            width: inherit;
            height: auto;
          }
          .monster-main {
            width: inherit;
            fill: $white;
            z-index: 20;
            position: relative;
          }
          .monster-shadow {
            width: inherit;
            position: absolute;
            top: 10px;
            left: 10px;
            fill: $rose;
            z-index: 10;
          }
        }
      }
      .list {
        background: $electric-blue;
        padding: rem-calc(73 27 23 27);
        margin-top: rem-calc(67);
        .the-team {
          font-family: $bungee-inline;
          color: $rose;
          font-size: rem-calc(36);
        }
        .items {
          padding-top: rem-calc(23);
          .item {
            padding-bottom: rem-calc(15);
            svg {
              width: rem-calc(33);
              height: rem-calc(24);
            }
            display: flex;
            justify-content: flex-start;
            .alien-icon {  width: 16%; fill: $teal-green2;  }
            .equal {  width: 5%; font-weight: bold;  }
            .name {  width: 40%; font-weight: bold; font-size: rem-calc(14); }
            .contacts {
              flex: 1;
              text-align: right;
              .contact {
                display: inline-block;
                text-align: center;
                fill: $white;
                margin: rem-calc(0 5);
                width: rem-calc(28);
                height: rem-calc(28);
                position: relative;
                &.dim {
                  opacity: .4;
                }
                svg {
                  fill: $white;
                  width: inherit;
                  height: inherit;
                }
              }
            }
          }
        }
      }
    }

    $mobile-L: 425; // added breakpoint so disclaimer & address will be in similar width to creditWrapperWidth
    .disclaimer-wrapper,
    .address-wrapper {
      max-width: rem-calc($creditWrapperWidth);
      margin: auto;
      padding: 0 rem-calc(15);

      @media (min-width: $mobile-L + 'px') {
        padding: 0;
      }
    }
    .disclaimer-wrapper {
      margin-top: rem-calc(10);
      margin-bottom: rem-calc(30);
      color: $light-salmon-pink;
      font-size: rem-calc(12);
      line-height: rem-calc(20);
      font-style: italic;

      @media (min-width: ($mobile-L + 15) + 'px') {
        max-width: rem-calc($mobile-L);
        text-align: center;
      }

      @include respond-to(tablet_down) {
        margin-bottom: rem-calc(20);
      }
    }

    .address-wrapper {
      color: $white;
      text-align: center;

      .address__header {
        font-size: rem-calc(19);
        line-height: rem-calc(23);
        font-weight: bold;
        text-transform: uppercase;
      }

      .address__body {
        font-size: rem-calc(18);
        line-height: rem-calc(28);
      }

      hr {
        border-color: $light-salmon-pink;
      }

      a, a:hover, a:active, a:focus {
        color: $white;
        text-decoration: none;
      }
    }

    .link--default {
      cursor: default;
    }
  }
</style>

<style lang="scss">
  #header nav.navigation{
    &.inpage {
      background: $cg-red;
    }

    &.inpage-menu {
      @include respond-to('desktop') {
        height: rem-calc(68);
        .navigation__hamburgerMenu {
          top: 50%;
          transform: translateY(-50%);
          height: initial;
        }
        .overlay-header{

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AboutUs.vue?bd4d1cda